export const documentExportRouteName: Record<string, string> = {
    doc_reconciliation: 'exportAct',
    doc_order: 'exportActAppointmentOfResponsible',
    doc_act: 'exportActExaminationOfHiddenWorks',
    doc_kp: 'exportProjectSummary',
    doc_contract: 'exportContractAgreement',
    doc_your_contract: 'exportCustomContractAgreement',
    doc_your_proposal: 'exportCustomCommercialProposal',
};
